import Card from 'antd/lib/card';
import Skeleton from 'antd/lib/skeleton';
import './informationCard.css';

interface IInformationCard {
    children: React.ReactNode;
    title: React.ReactNode | string;
    classNames?: string[];
    isLoading?: boolean;
}

export const InformationCard = ({ children, title, classNames = [], isLoading = false }: IInformationCard) =>
    isLoading ? (
        <Skeleton.Node active style={{ width: 140 }} />
    ) : (
        <Card size="small" className={`information-card ${classNames?.join(' ')}`}>
            <div className="information-card-title-container">{title}</div>
            <div className="information-card-content">{children}</div>
        </Card>
    );
